import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

// Slice для управления состоянием виджетов на дашбордах
export const DealTab = createSlice({
    name: "DealTab",
    initialState: {
        DealTab:undefined,
    },
    reducers: {
        setState: (state, {payload}) => {
            state.DealTab = payload.DealTab;
            return state;
        },
    },

});




export const { setState } = DealTab.actions;
export const DealTabSelector = (state) => state.DealTab;